import {IDataSetRequest, IDataSetResponse} from "./PA.DataSet.Services.IF";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import axios from 'axios'


export class DataSetService {

    getDataSet(aRequest: IDataSetRequest) : Promise<IDataSetResponse> {
        return new Promise<IDataSetResponse>((resolve, error) => {

            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/"));
            if (sEndPoint.endsWith('/')) {
                sEndPoint += 'dataSetService';
            } else {
                sEndPoint += '/dataSetService';
            }


            axios.post(sEndPoint, {data: {request: aRequest}})
                .then((resp:any) => {
                    let responseData = resp.data;
                    resolve(responseData);
                })
                .catch((err: any) => {
                    error(err);
                })
        })
    }

}